// Silent console filters for noisy browser font warnings (Chromium text shaper)
;(function(){
  try {
    const originalWarn = console.warn ? console.warn.bind(console) : null
    const originalError = console.error ? console.error.bind(console) : null

    const shouldSilence = (firstArg) => {
      const s = typeof firstArg === 'string' ? firstArg : (firstArg && firstArg.toString ? firstArg.toString() : '')
      if (!s) return false
      // Ignore unsupported OpenType shaping warnings
      if (/unsupported\s+(GPOS|GSUB)\s+table\s+LookupType/i.test(s)) return true
      return false
    }

    if (originalWarn) {
      console.warn = (...args) => {
        if (shouldSilence(args[0])) return
        originalWarn(...args)
      }
    }
    if (originalError) {
      console.error = (...args) => {
        if (shouldSilence(args[0])) return
        originalError(...args)
      }
    }
  } catch (_) {}
})()
